<template>
    <v-layout class="app-main-custom" :full-height="true">
        <v-app-bar color="info" :elevation="3">
            <template v-slot:prepend>
                <v-app-bar-nav-icon @click="handleToggleLeftNavigation"/>
            </template>
            <v-app-bar-title class="font-weight-bold">NỀN ĐỊA HÓA</v-app-bar-title>
            <template v-slot:append>
                <template v-if="isLoggedIn">
                    <div>
                        Xin chào, {{ userName }}
                    </div>
                    <div class="ms-3">
                        <logout-button-component></logout-button-component>
                    </div>
                </template>
                <template v-else>
                    <v-btn append-icon="mdi-login" @click="handleRedirectLogin">
                        ĐĂNG NHẬP
                    </v-btn>
                </template>
            </template>
        </v-app-bar>
        <v-main class="app-main-custom">
            <v-container :fluid="true" class="app-container-custom">
                <router-view></router-view>
            </v-container>
        </v-main>
    </v-layout>
</template>

<script>
import LogoutButtonComponent from '@/components/LogoutButtonComponent'

export default {
    name: 'MainLayout',
    components: { LogoutButtonComponent },
    data() {
        return {
            isShow: {
                leftNavigationDrawer: false,
            },
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters['user/authenticated']
        },
        userName() {
            return this.$store.getters['user/name']
        },
    },
    methods: {
        handleToggleLeftNavigation() {
            if (this.$store.getters['isShowLeftNavigationDrawer']) {
                this.$store.dispatch('closeLeftNavigationDrawer')
            } else {
                this.$store.dispatch('showLeftNavigationDrawer')
            }
        },
        handleRedirectLogin() {
            this.$router.push({ name: 'auth.login' })
        },
    },
}
</script>

<style lang="scss">
@import '@/styles/index.scss';
</style>
